import { render, staticRenderFns } from "./ArticleLayout.vue?vue&type=template&id=3cb1ae78&scoped=true"
import script from "./ArticleLayout.vue?vue&type=script&lang=js"
export * from "./ArticleLayout.vue?vue&type=script&lang=js"
import style0 from "./ArticleLayout.vue?vue&type=style&index=0&id=3cb1ae78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb1ae78",
  null
  
)

export default component.exports